import { UniObject } from '@uiwebkit/common';

export function uniAdjustClass(asideStart: boolean, sidebarStart: boolean, asideEnd: boolean, sidebarEnd: boolean)
  : UniObject<boolean> {
  return {
    'uni-adjust--sidebar-start': sidebarStart,
    'uni-adjust--aside-start': asideStart,
    'uni-adjust--aside-sidebar-start': asideStart && sidebarStart,
    'uni-adjust--sidebar-end': sidebarEnd,
    'uni-adjust--aside-end': asideEnd,
    'uni-adjust--aside-sidebar-end': asideEnd && sidebarEnd,
  };
}
